// extracted by mini-css-extract-plugin
module.exports = {"Toast":"Toast_Toast__3swpf","title":"Toast_title__3iITQ","detail":"Toast_detail__3lufT","ToastHost":"Toast_ToastHost__2wysG"};